import styled from '@emotion/styled';
import { Flex } from 'antd';

export const Toolbar = styled(Flex)`
  width: 100%;
  margin-bottom: 12px;
`;

export const TreeWrap = styled.div`
  /* The tree virtualises its own scroll area via the \`height\` prop. */
  .ant-tree {
    background: transparent;
    font-size: 13.5px;
  }
  .ant-tree .ant-tree-node-content-wrapper {
    width: 100%;
  }
`;

export const TitleRow = styled(Flex)<{ highlighted?: boolean }>`
  width: 100%;
  border-radius: 6px;
  transition: background 0.4s ease;
  background: ${({ theme, highlighted }) => (highlighted ? theme.colors.blueLight : 'transparent')};
`;

export const CompanyTitle = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const MemberName = styled.span`
  color: ${({ theme }) => theme.colors.blackSecondary};
`;

export const MemberEmail = styled.span`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 12px;
`;

export const LinkButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.link};

  &:hover {
    background: ${({ theme }) => theme.colors.blueLight};
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.textDisabled};
    cursor: not-allowed;
    background: none;
  }
`;

/* Coverage exceptions */
export const Coverage = styled(Flex)`
  width: 100%;
  padding-top: 4px;
`;

export const CoverageRow = styled(Flex)`
  width: 100%;
  font-size: 13px;
  line-height: 1.5;
`;

export const CoverageNames = styled.span`
  color: ${({ theme }) => theme.colors.blackSecondary};
`;

/** A single clickable company name inside the coverage exception lists. */
export const CoverageLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: ${({ theme }) => theme.colors.blackSecondary};

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.link};
    text-decoration: underline;
  }
`;

export const AllIncluded = styled(Flex)`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.success};
`;

/* Sync summary metrics */
export const Metrics = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
`;

export const Metric = styled.div`
  text-align: center;
  padding: 10px 4px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgGray};
`;

export const MetricValue = styled.div<{ tone?: 'added' | 'removed' }>`
  font-size: 19px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ theme, tone }) =>
    tone === 'added'
      ? theme.colors.success
      : tone === 'removed'
        ? theme.colors.yellow
        : theme.colors.black};
`;

export const MetricLabel = styled.div`
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.gray};
`;

/* Campaign stats */

/**
 * Capped, left-aligned tiles: the panel is full-width but shows a single tile
 * (send count) when Postmark engagement is unavailable and five when it is —
 * neither should stretch a tile across the whole card.
 */
export const StatMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 150px));
  justify-content: start;
  gap: 8px;
`;

export const MetricRate = styled.span`
  color: ${({ theme }) => theme.colors.link};
`;

export const StatFootnote = styled.p`
  margin: 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.gray};
  max-width: 90ch;
`;

/** The header block shown for copying: monospace, wrapped, never stretching the card. */
export const HeaderBlock = styled.pre`
  margin: 0;
  padding: 8px 10px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.bgGray};
  color: ${({ theme }) => theme.colors.dark};
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11.5px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;
